var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none",
    id: "Logo-Basic"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    id: "Logo-Basic-Triangle"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "13.371428489685059,26.742856979370117 26.22815704345703,4.114286422729492 39.08571243286133,26.742856979370117 13.371428489685059,26.742856979370117 ",
    id: "Fill-13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "m36.66109,27.73709l-5.3501,0l1.50609,2.60633l-25.51981,0l12.75949,-22.08061l1.6054,2.77811l2.67526,-4.62924l-3.41804,-5.91415c-0.3833,-0.66337 -1.34153,-0.66337 -1.72483,0l-19.05962,32.98111c-0.3833,0.66296 0.09561,1.49279 0.86261,1.49279l38.11926,0c0.76659,0 1.24591,-0.82983 0.86261,-1.49279l-3.31832,-5.74155"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTriangle);
export default __webpack_public_path__ + "static/media/logo-triangle.c27fc4768ea0d1fab84ad010471b4f0a.svg";
export { ForwardRef as ReactComponent };